<template>
  <b-container>
    <div>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </div>
    <b-modal
      ref="openModal"
      class="localizationModal"
      scrollable
      size="xl"
      :title="$t('checklist.template.templateCreate')"
    >
      <export-template-csv-crud
        :model="model"
        :editing="true"
      ></export-template-csv-crud>
      <!-- {{ id }} -->
      <!-- {{ model }} -->

      <template #modal-footer="{ cancel }">
        <div class="right">
          <b-button variant="green" @click="save" :disabled="canSubmit">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
      <!-- <pre class="language-json"><code>Model: {{ model }}</code></pre> -->
    </b-modal>
  </b-container>
</template>
<script>
export default {
  name: "ExportTemplateCsvEditModal",
  components: {
    ExportTemplateCsvCrud: () =>
      import(
        "@/components_rms/checklist/ExportTemplateCsv/ExportTemplateCsvCrud.vue"
      ),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  props: {
    id: String,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Template editado com sucesso",
      },
      model: {},
      canSubmit: false,
    };
  },
  methods: {
    show() {
      this.$refs.openModal.show();
      this.loadData();
    },
    loadData() {
      this.$apiChecklist
        .get("/exportTemplateCsv/getById/" + this.id)
        .then((response) => {
          this.model = response.data;
        })
        .catch((error) => {
          this.canSubmit = false;
          if (error.response.status == 401) {
            console.log(error.response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                console.log(error.response.data);
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    save() {
      this.canSubmit = true;
      this.$apiChecklist
        .post("/exportTemplateCsv/edit/", this.model)
        .then((response) => {
          this.canSubmit = false;
          this.$refs.openModal.hide();
          this.$refs.alert.show();
        })
        .catch((error) => {
          this.canSubmit = false;
          if (error.response.status == 401) {
            console.log(error.response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                console.log(error.response.data);
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
  },
};
</script>
<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>

